module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.138/js/sprocket_orange.svg"